import React from "react";
import { FiHome } from "react-icons/fi";
import { FaChevronRight } from "react-icons/fa";
import classNames from "classnames";
import IStyledProps from "../../utilities/IStyledProps";
import { usePageProps } from '../../context/PagePropContext';
import styled from "styled-components";

export interface IBlogBreadcrumbs extends IStyledProps {
    title?: string;
}

const BlogBreadcrumbs = (props: IBlogBreadcrumbs) => {
    const { className } = props;
    const { blogTitle, blogCategory} = usePageProps(); // these props come in separate from 'props' because they need to be in frontmatter for meta tags

    return (
        <div className={classNames('text-white text-uppercase', className)}>
            <a href="/must-reads" className="text-decoration-none text-white title-link">
                <FiHome className="me-2" />
            </a>
            <span className="chevron"><FaChevronRight width={24} /></span>
            <a href={`/must-reads/${blogCategory}`} className="text-decoration-none text-white title-link">
                {blogCategory}
            </a>
            <span className="chevron"><FaChevronRight width={24} /></span>
            <span className="title">{blogTitle}</span>
        </div>
    );
};

export default styled(BlogBreadcrumbs)`
    padding: 0.722rem 1.5rem;
    background: var(--carbon);
    overflow-x: auto;
    /* Uncomment to hide scrollbars in all browsers */
    /* scrollbar-width: none; // Firefox
    -ms-overflow-style: none; // IE 10+
    &::-webkit-scrollbar { // WebKit
        width: 0;
        height: 0;
    } */
    white-space: nowrap;
    .chevron {
        color: #fff;
        margin: 0 0.5rem;
    }
    @media (min-width: 768px) {
        overflow-x: visible;
        white-space: wrap;
        background: transparent;
        padding: 3rem 0 3rem 4rem;
    }
    @media (min-width: 1440px) {
        padding-left: 0;
    }

`;